var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgSendAutopilot = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1171_5971)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9975 8.21443C12.0581 8.08368 12.1892 8 12.3333 8C12.4774 8 12.6085 8.08368 12.6691 8.21443L13.6328 10.2926C13.6404 10.3089 13.6507 10.3238 13.6635 10.3365C13.6762 10.3492 13.691 10.3596 13.7074 10.3672L15.7855 11.3308C15.9163 11.3915 16 11.5225 16 11.6667C16 11.8108 15.9163 11.9419 15.7855 12.0025L13.7074 12.9662C13.691 12.9737 13.6762 12.9841 13.6635 12.9968C13.6507 13.0096 13.6404 13.0244 13.6328 13.0407L12.6691 15.1189C12.6085 15.2497 12.4774 15.3333 12.3333 15.3333C12.1892 15.3333 12.0581 15.2497 11.9975 15.1189L11.0338 13.0407C11.0262 13.0244 11.0158 13.0096 11.0031 12.9968C10.9904 12.9841 10.9755 12.9737 10.9592 12.9662L8.88106 12.0025C8.75028 11.9419 8.66663 11.8108 8.66663 11.6667C8.66663 11.5225 8.75028 11.3915 8.88106 11.3308L10.9592 10.3672C10.9755 10.3596 10.9904 10.3492 11.0031 10.3365C11.0158 10.3238 11.0262 10.3089 11.0338 10.2926L11.9975 8.21443Z",
    fill: "#7A5AF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3334 1.3335L7.26669 9.08192M15.3334 1.3335L0.666687 6.26431L7.26669 9.08192M15.3334 1.3335L13.3835 7.20146M7.26669 9.08192L8.00002 10.6668",
    stroke: "#7A5AF8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1171_5971"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSendAutopilot, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/send-autopilot.321126c9.svg";
export { ForwardRef as ReactComponent };